module.exports = __webpack_public_path__ + "static/media/transformers.bc10a479.mp3";